import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const SwiperPauseIcon = (props) => (
  <SVGUniqueID>
    <svg
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 5v14M17 5v14"
        stroke="#000"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  </SVGUniqueID>
);
export { SwiperPauseIcon };
